<template>
  <section class="why-choose-us">
    <div class="section-inner">
      <h2 class="section-title fade-in-section">{{ t('home.whyChoose.title') }}</h2>
      <div class="reason-grid">
        <article
          v-for="itemKey in itemKeys"
          :key="itemKey"
          class="reason-card fade-in-section"
        >
          <h3 class="reason-title">{{ t(`home.whyChoose.items.${itemKey}.title`) }}</h3>
          <p class="reason-description">{{ t(`home.whyChoose.items.${itemKey}.description`) }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'

export default {
  name: 'WhyChooseUs',
  setup() {
    const { t } = useTranslation()
    const itemKeys = ['item1', 'item2', 'item3', 'item4']

    return {
      t,
      itemKeys
    }
  }
}
</script>

<style lang="scss" scoped>
.why-choose-us {
  padding: 88px 20px 96px;
  background: #ffffff;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.section-title {
  margin: 0 0 36px;
  text-align: center;
  font-size: clamp(24px, 3vw, 32px);
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.reason-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.reason-card {
  padding: 24px;
  border-top: 3px solid #1a7fb0;
  background: #f7f9fc;
  border-radius: 0 0 12px 12px;
}

.reason-title {
  margin: 0 0 10px;
  font-size: 17px;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.reason-description {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

@media (max-width: 900px) {
  .reason-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .reason-grid {
    grid-template-columns: 1fr;
  }
}
</style>
